import SessionStorage from '../../../../shared/services/SessionStorage';
import TokensService from '../../../../shared/services/TokensService';
import { HostAppMessageEvent } from '../types/message';

/**
 * Service to handle Cognito tokens received from the host app (web-app) via postMessage
 */
export default class TokensBroker {
  private readonly hostAppUrl = new URL(import.meta.env.VITE_APP_URL);
  private readonly tokensService = new TokensService(
    SessionStorage.getInstance(),
  );
  private resolveTokensPromise?: () => void;

  private handleMessage = (event: HostAppMessageEvent) => {
    if (event.origin !== this.hostAppUrl.origin) {
      return;
    }

    switch (event.data.type) {
      case 'TOKENS': {
        this.tokensService.storeTokens(event.data.payload.tokens);

        if (this.resolveTokensPromise) {
          this.resolveTokensPromise();
          this.resolveTokensPromise = undefined;
          window.removeEventListener('message', this.handleMessage);
        }

        break;
      }

      default:
        break;
    }
  };

  /**
   * Wait for tokens to be received from the host app
   * @returns Promise that resolves when tokens are received
   */
  waitForTokens(): Promise<void> {
    return new Promise((resolve) => {
      this.resolveTokensPromise = resolve;
      window.addEventListener('message', this.handleMessage);
    });
  }
}
